import { UserCircleIcon } from '@heroicons/react/outline';

import styles from '../../agents.module.css';

import clsxm from '@/lib/clsxm';

import { useChannelsT } from '../useChannelsT';
import { delay, tone } from '../../primitives';

/**
 * The chat's JavaScript API: open it from your own button and tell the agent
 * who is signed in, then the conversation labelled with that person.
 */
export default function WidgetApi({ page }: { page: string }) {
  const { t } = useChannelsT();

  return (
    <div className='relative mx-auto max-w-[31rem] pb-2 sm:pb-16'>
      <pre
        dir='ltr'
        className='overflow-x-auto rounded-[22px] bg-[#0f0e20] px-5 py-5 text-left font-mono text-[12px] leading-[1.7] text-[#c9c9e3] shadow-[0_40px_90px_-30px_rgba(0,0,0,0.7)] ring-1 ring-inset ring-white/10'
      >
        <code>
          <span className='text-[#7d7da0]'>
            {'// '}
            {t('Open the chat from your own button')}
          </span>
          {'\n'}
          <span className='text-[#9aa7ff]'>button</span>.
          <span className='text-[#7fd6c2]'>onclick</span> = () =&gt;
          {'\n  '}window.<span className='text-[#7fd6c2]'>easyPeasyChat</span>.
          <span className='text-[#f2c98b]'>open</span>();
          {'\n\n'}
          <span className='text-[#7d7da0]'>
            {'// '}
            {t('Tell the agent who is signed in')}
          </span>
          {'\n'}window.<span className='text-[#7fd6c2]'>easyPeasyChat</span>.
          <span className='text-[#f2c98b]'>setContact</span>({'{'}
          {'\n  '}email:{' '}
          <span className='text-[#f2c98b]'>&apos;jane@example.com&apos;</span>,
          {'\n  '}name:{' '}
          <span className='text-[#f2c98b]'>&apos;Jane Doe&apos;</span>,{'\n'}
          {'}'});
        </code>
      </pre>

      <div
        className={clsxm(
          styles.rv,
          'relative mt-4 flex items-start gap-3 rounded-2xl p-4 text-start shadow-[0_30px_60px_-24px_rgba(0,0,0,0.65)] sm:absolute sm:-bottom-2 sm:end-[-1.5rem] sm:mt-0 sm:w-[18rem]',
          tone.surface,
          tone.line,
        )}
        style={delay(450)}
      >
        <UserCircleIcon className='h-9 w-9 flex-none text-primary-600 dark:text-primary-400' />
        <span className='min-w-0'>
          <span className={clsxm('block text-[13px] font-semibold', tone.ink)}>
            Jane Doe
          </span>
          <span className={clsxm('block truncate text-xs', tone.quiet)}>
            <span dir='ltr'>jane@example.com</span>
          </span>
          <span className={clsxm('mt-1.5 block text-xs', tone.body)}>
            {t('Started the chat on {{page}}', { page })}
          </span>
        </span>
      </div>
    </div>
  );
}
